import { useEffect, useState } from 'react';
import { deviceClass } from './pageContext';

// On phones the launcher and opener cover the inline quote form, so they step aside while it is on screen.
export function useQuoteFormOnScreen(): boolean {
  const [onScreen, setOnScreen] = useState(false);

  useEffect(() => {
    const form = document.querySelector('[data-quote-form]');
    if (!form || deviceClass() !== 'mobile') return;
    const observer = new IntersectionObserver(([entry]) => setOnScreen(entry.isIntersecting));
    observer.observe(form);
    return () => observer.disconnect();
  }, []);

  return onScreen;
}
